var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserPaymentsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #6238f9;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.4px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.907,12.914c-.111-.013-.218-.028-.32-.044-.847-.135-1.558-.588-2.209-1.079l-1.68-1.269c-.592-.447-1.471-.447-2.063,0-.533.403-.696,1.065-.359,1.606.393.63.947,1.436,1.479,1.929.533.493,1.325.934,1.972,1.246.717.346,1.509.545,2.315.676,1.634.264,3.337.224,4.954-.109.914-.188,1.864-.286,2.803-.286h2.1M8.009,12.925c-.034-.004-.068-.007-.102-.011M16.9,11.73c-2.444-1.733-6.489-2.914-9.088-1.363-.157.093-.297.206-.418.341-.519.583-.481,1.462.117,1.984.126.11.261.194.396.223M8.009,12.925c-.034,0-.068-.004-.102-.011M9.695,12.928c-.631.06-1.2.047-1.687-.003"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10.294,
    cy: 4.411,
    r: 2.353
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.312,3.154c-.339-.189-.724-.307-1.14-.307-1.299,0-2.353,1.053-2.353,2.353s1.053,2.353,2.353,2.353c.836,0,1.565-.439,1.982-1.095"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPaymentsIcon);
export default __webpack_public_path__ + "static/media/user-payments-icon.f53e95d70bdd2778542bd47297e9b06f.svg";
export { ForwardRef as ReactComponent };